"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfShiftViewedByNursePropertiesDto = instanceOfShiftViewedByNursePropertiesDto;
exports.ShiftViewedByNursePropertiesDtoFromJSON = ShiftViewedByNursePropertiesDtoFromJSON;
exports.ShiftViewedByNursePropertiesDtoFromJSONTyped = ShiftViewedByNursePropertiesDtoFromJSONTyped;
exports.ShiftViewedByNursePropertiesDtoToJSON = ShiftViewedByNursePropertiesDtoToJSON;
exports.ShiftViewedByNursePropertiesDtoToJSONTyped = ShiftViewedByNursePropertiesDtoToJSONTyped;
const ShiftViewedByNurseSource_1 = require("./ShiftViewedByNurseSource");
/**
 * Check if a given object implements the ShiftViewedByNursePropertiesDto interface.
 */
function instanceOfShiftViewedByNursePropertiesDto(value) {
    if (!('shiftId' in value) || value['shiftId'] === undefined)
        return false;
    if (!('source' in value) || value['source'] === undefined)
        return false;
    return true;
}
function ShiftViewedByNursePropertiesDtoFromJSON(json) {
    return ShiftViewedByNursePropertiesDtoFromJSONTyped(json, false);
}
function ShiftViewedByNursePropertiesDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'shiftId': json['shiftId'],
        'source': (0, ShiftViewedByNurseSource_1.ShiftViewedByNurseSourceFromJSON)(json['source']),
    };
}
function ShiftViewedByNursePropertiesDtoToJSON(json) {
    return ShiftViewedByNursePropertiesDtoToJSONTyped(json, false);
}
function ShiftViewedByNursePropertiesDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'shiftId': value['shiftId'],
        'source': (0, ShiftViewedByNurseSource_1.ShiftViewedByNurseSourceToJSON)(value['source']),
    };
}
//# sourceMappingURL=ShiftViewedByNursePropertiesDto.js.map